import React from 'react';
import {
  bool, func, node, oneOfType, oneOf,
} from 'prop-types';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';
import {
  Flex, Button, Typography, Icon,
} from '@atoms';
import { ReactComponent as Chat } from '@assets/chat.svg';
import { ReactComponent as Back } from '@assets/back.svg';
import { routes } from '@constants';

const Footer = ({
  onBackUp,
  hasBackUpButton,
  hasHelpMeButton,
  children,
}) => {
  const history = useHistory();

  const onHelpMe = () => {
    history.push(routes.helpMe);
  };

  return (
    <Wrapper padding="md" justifyBetween>
      <BackUpFlex
        column
        grow={0}
        selfStart
        itemsCenter
        hasBackUpButton={hasBackUpButton}
        marginRight="xl2"
      >
        <Button.Circular
          diameter={58}
          primaryInverted
          marginBottom="xxs"
          onClick={onBackUp}
        >
          <Flex itemsCenter justifyCenter>
            <Icon SVG={Back} width="22px" height="22px" />
          </Flex>
        </Button.Circular>
        <Button.Rectangular padding="xs" onClick={onBackUp} primaryInverted>
          <Typography size="sm">
            BACK UP
          </Typography>
        </Button.Rectangular>
      </BackUpFlex>
      {children && (
        <Flex selfStart>
          {children}
        </Flex>
      )}
      <HelpMeFlex
        hasHelpMeButton={hasHelpMeButton}
        itemsCenter
        column
        grow={0}
        selfEnd
        marginLeft="xl2"
      >
        <Button.Circular
          className="help"
          diameter={58}
          primary
          marginBottom="xxs"
          onClick={onHelpMe}
        >
          <Flex itemsCenter justifyCenter>
            <Icon SVG={Chat} width="22px" height="22px" />
          </Flex>
        </Button.Circular>
        <Button.Rectangular onClick={onHelpMe} padding="xs" primary>
          <Typography size="sm">
            HELP ME!
          </Typography>
        </Button.Rectangular>
      </HelpMeFlex>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  ${({ theme: { color } }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    pointer-events: none;

    ${Button.Circular}, ${Button.Rectangular} {
      pointer-events: all;
    }

    .help {
      &:active {
        svg {
          path {
            stroke: ${color.strawberry};
            fill: ${color.white};
          }
        }
      }
    }
  `}
`;

const BackUpFlex = styled(Flex)`
  ${({ hasBackUpButton }) => css`
    visibility: ${hasBackUpButton ? 'visible' : 'hidden'};
  `}
`;

const HelpMeFlex = styled(Flex)`
  ${({ hasHelpMeButton }) => css`
    visibility: ${hasHelpMeButton ? 'visible' : 'hidden'};
  `}
`;

Footer.defaultProps = {
  hasHelpMeButton: true,
  hasBackUpButton: true,
  children: null,
  onBackUp: () => {},
};

Footer.propTypes = {
  children: oneOfType([oneOf([null]), node]),
  hasHelpMeButton: bool,
  hasBackUpButton: bool,
  onBackUp: func,
};

export default Footer;
